import React from "react";
import ReCaptcha from "react-google-recaptcha";

export default function Recaptcha({ recaptchaRef, onChange }) {
  // const { GATSBY_RECAPTCHA_SITEKEY } = process.env;
  return (
    <ReCaptcha
      ref={recaptchaRef}
      sitekey={`6LeiWiUfAAAAAM3WspWhJTMhtj4f5jWsG6kUA-iJ`}
      size="normal"
      onChange={onChange}
    />
  );
}
